import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const Restart = ({ isOpen, onClose, onConfirm }) => {
  const navigate = useNavigate();

  const handleConfirmYes = () => {
    onClose();
    if (onConfirm) {
      onConfirm();
    } else {
      navigate('/');
      window.location.reload();
    }
  };

  const handleConfirmCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-pl_bg_light_3 p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
        <h2 className="text-lg font-semibold text-pl_txt_dark_5 mb-4">
          Leave and Start Again
        </h2>
        <p className="text-pl_txt_dark_4 mb-6">
          Are you sure you want to leave and start again?
        </p>
        <div className="flex flex-wrap justify-center gap-4">
        <button
            onClick={handleConfirmCancel}
            className="min-w-[120px] px-4 py-2 rounded-full bg-gray-200 text-pl_txt_dark_5 hover:bg-gray-300 transition text-sm text-center"
        >
            Cancel
        </button>
        <button
            onClick={handleConfirmYes}
            className="min-w-[120px] px-4 py-2 rounded-full bg-pl_prim_color_1 text-white hover:bg-opacity-90 transition text-sm text-center"
        >
            Yes, restart
        </button>
        </div>
      </div>
    </div>
  );
};

Restart.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

export default Restart;
